module.exports = __webpack_public_path__ + "static/media/video.083de7a5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/videos/video.mp4
// module id = 293
// module chunks = 0